import LogicFlow from '@logicflow/core';
import { useCallback, useRef, useState } from 'react';

interface UseDataMapNodeOperationsProps {
  lfRef?: React.RefObject<LogicFlow | null>;
}

const useDataMapNodeOperations = ({ lfRef }: UseDataMapNodeOperationsProps) => {
  // 节点菜单相关状态
  const [selectedNodeId, setSelectedNodeId] = useState<string | null>(null);
  const selectedNodeIdRef = useRef<string | null>(null);

  const [nodeMenuPosition, setNodeMenuPosition] = useState<{
    x: number;
    y: number;
  } | null>(null);
  const [showNodeMenu, setShowNodeMenu] = useState(false);
  const [showMenuDropdown, setShowMenuDropdown] = useState(false);

  const handleNodeClick = useCallback((nodeData: any, event: any) => {
    event.stopPropagation();
    console.log('Node clicked:', nodeData);
    setSelectedNodeId(nodeData.id);
    selectedNodeIdRef.current = nodeData.id;

    // 计算菜单位置
    const rect = event.target.getBoundingClientRect();
    const menuX = rect.right + 10; // 菜单显示在节点右侧10px处
    const menuY = rect.top; // 菜单顶部对齐节点顶部

    setNodeMenuPosition({ x: menuX, y: menuY });
    setShowNodeMenu(true);
  }, []);

  // 删除节点
  const handleDeleteNode = useCallback(() => {
    if (selectedNodeId && lfRef?.current) {
      console.log('Deleting node:', selectedNodeId);
      lfRef.current.deleteNode(selectedNodeId);
      hideNodeMenu();
    }
  }, [selectedNodeId, lfRef]);

  const toggleMenuDropdown = useCallback((event: React.MouseEvent) => {
    event.stopPropagation();
    setShowMenuDropdown(!showMenuDropdown);
  }, []);

  // 隐藏节点菜单
  const hideNodeMenu = useCallback(() => {
    setShowNodeMenu(false);
    setSelectedNodeId(null);
    selectedNodeIdRef.current = null;
    setNodeMenuPosition(null);
    setShowMenuDropdown(false);
  }, []);

  return {
    // 状态
    selectedNodeId,
    selectedNodeIdRef,
    nodeMenuPosition,
    showNodeMenu,
    showMenuDropdown,
    setShowMenuDropdown,

    // 方法
    handleNodeClick,
    toggleMenuDropdown,
    hideNodeMenu,
    handleDeleteNode,
  };
};

export default useDataMapNodeOperations;
